
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'TheLoadingAnimation',
})
export default class TheLoadingAnimation extends Vue {
  @Prop({default: false, required: true})
  private readonly value: boolean;

  @Prop({default: true, required: false})
  private readonly indeterminate: boolean;

  @Prop({default: 0, required: false})
  private readonly loadingPercentage: number;

  @Prop({default: '', required: false})
  private readonly appendedText: string;

  @Prop({default: false, required: false})
  private readonly cancelVisible: boolean;

  private actionDisabled = false;

  @Watch('value')
  private valueOnInput(newValue: boolean): void {
    this.actionDisabled = newValue ? !newValue : this.actionDisabled;
  }

  public emitCancelClick() {
    this.actionDisabled = true;
    this.$emit('click:cancel');
  }
};
